var React = require('react');

function PlusIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"id":"Path_2282","d":"M0,0H24V24H0Z","fill":"none","key":0}),React.createElement("path",{"id":"Path_2399","data-name":"Path 2399","d":"M20,11.2H12.8V4H11.2v7.2H4v1.5h7.2V20h1.6V12.7H20Z","fill":"#111","key":1})]);
}

PlusIcon.defaultProps = {"id":"icon_","data-name":"icon / +","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = PlusIcon;

PlusIcon.default = PlusIcon;
